/* v1.8.6.9 — Prime Shopper follow sticky CTA (all devices)
   Hero visible -> hidden / Hero passed and final CTA outside -> visible / final CTA visible -> hidden.
*/
(function () {
  var bar = document.getElementById('ps-sticky');
  if (!bar) return;
  var hero = document.querySelector("[data-ps-section='S1']");
  var finalCta = document.getElementById('s15');
  var heroVisible = true;
  var finalVisible = false;
  var observers = [];
  function setState(state) {
    if (bar.getAttribute('data-state') !== state) {
      bar.setAttribute('data-state', state);
      bar.setAttribute('aria-hidden', state === 'visible' ? 'false' : 'true');
    }
  }
  function update() { setState(!heroVisible && !finalVisible ? 'visible' : 'hidden'); }
  function setup() {
    if (typeof IntersectionObserver !== 'function') { setState('hidden'); return; }
    observers.forEach(function (o) { o.disconnect(); }); observers = [];
    if (hero) {
      var ho = new IntersectionObserver(function(entries){entries.forEach(function(e){heroVisible=e.isIntersecting;});update();},{threshold:0});
      ho.observe(hero); observers.push(ho);
    } else { heroVisible=false; }
    if (finalCta) {
      var fo = new IntersectionObserver(function(entries){entries.forEach(function(e){finalVisible=e.isIntersecting;});update();},{threshold:0});
      fo.observe(finalCta); observers.push(fo);
    } else { finalVisible=false; }
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();
